import { z } from 'zod';

/////////////////////////////////////////
// STOCK REPLY SCHEMA
/////////////////////////////////////////

export const StockReplySchema = z.object({
  stockreplyId: z.number().int(),
  cityId: z.number().int(),
  defaultSet: z.number().int(),
  stockName: z.string(),
  stockText: z.string(),
  personId: z.number().int(),
  departmentId: z.number().int(),
  classificationId: z.number().int(),
})

export type StockReply = z.infer<typeof StockReplySchema>

export default StockReplySchema;
